<template>
  <div class="patient-main-layout" v-if="userStore.role === 'patient'">
    <PatientSideBar :active-page="currentRouteName" />
    <div class="content-area">
      <PatientTopBar />
      <main class="main-content">
        <router-view></router-view>
      </main>
    </div>
  </div>
  <div class="patient-main-layout" v-if="userStore.role === 'doctor'">
    <SideBar :active-page="currentRouteName" />
    <div class="content-area">
      <TopBar />
      <main class="main-content">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/store'; // 导入 Pinia Store
import SideBar from '@/view/ForDoctor/includes/SideBar.vue';
import TopBar from '@/view/ForDoctor/includes/TopBar.vue';
import PatientSideBar from '@/view/ForPatient/includes/SideBar.vue';
import PatientTopBar from '@/view/ForPatient/includes/TopBar.vue';

const route = useRoute();
const userStore = useUserStore(); // 初始化 Pinia Store
const currentRouteName = computed(() => route.name);
</script>

<style scoped>
.patient-main-layout {
  display: flex;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}
.main-layout {
  display: flex;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

.content-area {
  flex: 1;
  margin-left: min(200px, 27.8vw);
  width: calc(100% - min(200px, 27.8vw));
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 ;
}

.main-content {
  padding: min(15px, 2.1vw);
  background: rgb(252,252,255);
  min-height: calc(100vh - min(70px, 9.7vh));
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  font-size: min(14px, 1.9vw);
}

@media screen and (max-width: 768px) {
  .content-area {
    margin-left: min(60px, 8.3vw);
    width: calc(100% - min(60px, 8.3vw));
    padding: min(10px, 1.4vw);
  }
  
  .main-content {
    padding: min(10px, 1.4vw);
    min-height: calc(100vh - min(60px, 8.3vh));
  }
}
</style>
